module.exports = __webpack_public_path__ + "static/media/hero-top.56ef59a2.jpg";